import { inject } from "mobx-react";
import type { IAppStores } from "./AppMaster";

type IStoresToProps<TStores, TProps extends object> = (stores: TStores) => TProps;

export function injectFromApp<TProps extends object>(fn: IStoresToProps<IAppStores, Partial<TProps>>) {
    return inject(fn);
}
